module.exports = __webpack_public_path__ + "static/media/MainLabor.a5806ee8.jpg";